import logo from './img/logo.png';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro'

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Diamond Client</h1>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          A FREE Minecraft 1.8.8 PVP Client
        </p>
        <a
          className="download"
          href="/download" 
        >
          <button className='download-button'><FontAwesomeIcon className='download-button-icon' icon={solid('download')} /> Download Diamond Client!</button>
        </a>
      </header>
    </div>
  );
}

export default Home;
